import { ICard } from '~/types/card'
import http from '~/utils/http'

export function getOrder(page: number, size: number, phoneNumber?: string) {
  return http.get('/admin/card', {
    params: {
      page,
      size,
      ...(phoneNumber ? { phoneNumber } : {}),
    },
  })
}

export function patchCard(id: number, data: Partial<ICard>) {
  return http.patch(`/admin/card/${id}`, data)
}
